/** Bottom status bar: current element type, page count, zoom, save state. */
export interface StatusBarProps {
  elementType: string | null;
  pageCount?: number;
  saved: boolean;
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
}

export function StatusBar({
  elementType,
  pageCount,
  saved,
  zoom,
  onZoomIn,
  onZoomOut,
}: StatusBarProps) {
  return (
    <footer className="sp-statusbar">
      <span className="sp-element">{elementType ?? "—"}</span>
      {pageCount !== undefined && (
        <span className="sp-pagecount">
          ~{pageCount} {pageCount === 1 ? "page" : "pages"}
        </span>
      )}
      <span className="sp-status-spacer" />
      <div className="sp-zoom">
        <button className="sp-zoom-btn" onClick={onZoomOut} aria-label="Zoom out">
          −
        </button>
        <span className="sp-zoom-val">{Math.round(zoom * 100)}%</span>
        <button className="sp-zoom-btn" onClick={onZoomIn} aria-label="Zoom in">
          +
        </button>
      </div>
      <span className="sp-savestate">{saved ? "Saved" : "Unsaved"}</span>
    </footer>
  );
}
